import React, { useState } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import Page from "../../finwell/pages/Page";
import "./CoachingRequestForm.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllSkills,
  coachingRequestSubmit,
  coachingRequestSubmitClear,
  getAllSkillsClear,
} from "../../redux/coaching/actions";
import { SessionKeys } from "../../utils/AppUtils";
import { useEffect } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import Select from "react-select";
import { t } from "i18next";

const CoachingRequestForm = () => {
  const [step, setStep] = useState(1);
  const [skills, setSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedIntrest, setselectedIntrest] = useState([]);
  const [areaofInterest, setAreaofInterest] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [chips, setChips] = useState([]);
  const [inputValueInterest, setInputValueInterest] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showSuggestionsInterest, setShowSuggestionsInterest] = useState(false);
  const [filteredSuggestionsInterest, setFilteredSuggestionsInterest] =
    useState([]);
  const [interestChips, setInterestChips] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [userDetails, setUserDetails] = useState({
    name: "",
    role: "",
    email: "",
    location: "",
  });
  const [skillsList, setSkillsList] = useState([]);
  const [skillSet, setSkillSet] = useState([]);
  const [selectedSkillSet, setSelectedSkillSet] = useState(() => {
    const savedSkills = localStorage.getItem("selectedSkillSet");
    return savedSkills ? JSON.parse(savedSkills) : []; // Parse saved skills if present
  });
  const [defaultValue, setDefaultValue] = useState([]);
  const [experience, setExperience] = useState([
    { id: "1", value: "No Experience" },
    { id: "2", value: "Less than 1 year" },
    { id: "3", value: "1-2 years" },
    { id: "4", value: "3-5 years" },
    { id: "5", value: "6-10 years" },
    { id: "6", value: "More than 10 years" },
  ]);
  const [selectedExperience, setSelectedExperience] = useState( localStorage.getItem("selectedExperience") || "");
  const [selectedIndustry, setSelectedIndustry] = useState(() => {
    return localStorage.getItem("selectedIndustry") || ""; 
  });
  const [industry, setIndustry] = useState([]);
  const[industryError, setIndustryError] = useState('')
  const [skillError, setSkillError] = useState('');
  const [interestError, setInterestError] = useState('');
  const [experienceError, setExperienceError] = useState("");
  const [skillsError, setSkillsError] = useState("");

  const [mentorNames, setMentorNames] = useState([]);
  const [error, setError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(() => {
    return localStorage.getItem("phoneNumber") || ""; 
  });
  const [preferredMode, setPreferredMode] = useState(() => {
    return localStorage.getItem("preferredMode") || ""; 
  });
  const [directReports, setDirectReports] = useState(() => {
    return localStorage.getItem("directReports") || ""; 
  });
  const [mentoringPeriod, setMentoringPeriod] = useState(() => {
    return localStorage.getItem("mentoringPeriod") || ""; 
  });
  
  let skillErrorTimeout;
  let interestErrorTimeout;
  const userDetailRes = useSelector((state) => state.user.userBroker);

  const dispatch = useDispatch();
  const coachingStore = useSelector(state => state.coaching)
  const navigate = useNavigate();

  const showErrorWithTimeout = (setError, message) => {
    setError(message);

    // Clear any existing timeout
    if (setError === setSkillError && skillErrorTimeout) {
      clearTimeout(skillErrorTimeout);
    } else if (setError === setInterestError && interestErrorTimeout) {
      clearTimeout(interestErrorTimeout);
    }

    // Set a new timeout to clear the error after 5 seconds
    const timeout = setTimeout(() => {
      setError('');
    }, 5000);

    if (setError === setSkillError) {
      skillErrorTimeout = timeout;
    } else if (setError === setInterestError) {
      interestErrorTimeout = timeout;
    }
  };

  const validateFields = () => {
    let isValid = true;

    // Validate skills
    if (selectedSkills.length === 0) {
      showErrorWithTimeout(setSkillError, 'Please select at least one skill.');
      isValid = false;
    } else {
      setSkillError(''); // Clear the error if validation passes
    }

    // Validate areas of interest
    if (selectedIntrest.length === 0) {
      showErrorWithTimeout(setInterestError, 'Please select at least one area of interest.');
      isValid = false;
    } else {
      setInterestError(''); // Clear the error if validation passes
    }

    return isValid;
  };
  useEffect(() => {
    // Save selected industry to localStorage whenever it changes
    localStorage.setItem("selectedIndustry", selectedIndustry);
  }, [selectedIndustry]);
  useEffect(() => {
    // Save preferred mode to localStorage whenever it changes
    localStorage.setItem("preferredMode", preferredMode);
  }, [preferredMode]);
  useEffect(() => {
    // Save mentoringPeriod to localStorage whenever it changes
    localStorage.setItem("mentoringPeriod", mentoringPeriod);
  }, [mentoringPeriod]);
  useEffect(() => {
    // Save directReports to localStorage whenever it changes
    localStorage.setItem("directReports", directReports);
  }, [directReports]);
  useEffect(() => {
    // Save directReports to localStorage whenever it changes
    localStorage.setItem("phoneNumber", phoneNumber);
  }, [phoneNumber]);
  const handleSubmit = (e) => {
    e.preventDefault();

    // Perform validation
    if (!validateFields()) {
      return; // Stop submission if validation fails
    }
    setIsLoading(true);
    // If valid, submit the form
    const data = {
      module: "submitCoachingForm",
      postData: {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
        skill: selectedSkills,
        interest: selectedIntrest,
        sort_by: "ASC",
        mentor_names: mentorNames ? [mentorNames] : [], 
        phoneNumber:phoneNumber,
        selectedSkillSet:selectedSkillSet,
        experience:selectedExperience,
        industrySegment:selectedIndustry
      },
    };
    dispatch(coachingRequestSubmit(data));
  };
  useEffect(() => {

    console.log("coachingStore", coachingStore.coachingRequestSubmitList)
    if (!_.isEmpty(coachingStore.coachingRequestSubmitList)) {

      const coachingRequestSubmitListing = coachingStore.coachingRequestSubmitList;
      if (coachingRequestSubmitListing?.status === "success") {
        // console.log("success inside coachingRequestSubmitList")
        // localStorage.setItem(
        //     "coachingRequestData",
        //     JSON.stringify(coachingRequestSubmitListing)
        // );
        dispatch(coachingRequestSubmitClear({}))
        setIsLoading(false);
        navigate("/suggested-coaches", { state: { coachesData: coachingRequestSubmitListing } });
      } else {
        setSkills([]);
      }

    }
  }, [coachingStore.coachingRequestSubmitList]);

  const getAllSkillsAPI = () => {
    setIsLoading(true);
    dispatch(
      getAllSkills({
        module: "getAllSkills",
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
      })
    );
  };

  useEffect(() => {
    getAllSkillsAPI();
    return () => {
      dispatch(getAllSkillsClear());
    };
  }, [dispatch]);
  useEffect(() => {
    const savedSkills = JSON.parse(localStorage.getItem('selectedSkills')) || [];
    const savedInterests = JSON.parse(localStorage.getItem('selectedInterests')) || [];
    
    setSelectedSkills(savedSkills);
    setselectedIntrest(savedInterests);
  
    const savedChips = savedSkills.map((skillId) => skills.find(skill => skill.id === skillId));
    const savedInterestChips = savedInterests.map((interestId) => areaofInterest.find(interest => interest.id === interestId));
  
    setChips(savedChips.filter(Boolean)); // Avoid null values
    setInterestChips(savedInterestChips.filter(Boolean)); // Avoid null values
  }, [skills, areaofInterest]);
  useEffect(() => {
    console.log("coachingStore", coachingStore);
    if (!_.isEmpty(coachingStore.skillsList)) {
      const skillListing = coachingStore.skillsList;
      if (skillListing?.status === "success") {
        console.log("success");
        setSkills(skillListing?.payload?.payload?.skill);
        setAreaofInterest(skillListing?.payload?.payload?.interest);
        setIndustry(skillListing?.payload?.payload?.industry);
        let list = skillListing?.payload?.payload?.skill;
        setSkillSet(list);
        setSkillsList(
          _.map(list, (skill) => {
            return {
              value: skill?.id,
              label: skill?.name,
            };
          })
        );
        setIsLoading(false);
        // console.log("coachingSkills", coachingStore.skillsList);
      } else {
        setSkills([]);
        setIsLoading(false);
      }
    }
  }, [coachingStore]);

  const handleNext = () => setStep((prev) => prev + 1);
  const handlePrevious = () => setStep((prev) => prev - 1);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Show dropdown only when the input length is 3 or more
    if (value.length >= 3) {
        const suggestions = skills.filter((skill) =>
            skill.name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredSuggestions(suggestions);
        setShowSuggestions(true); // Show suggestions dropdown
    } else {
        setFilteredSuggestions([]); // Clear suggestions
        setShowSuggestions(false); // Hide suggestions dropdown
    }
};


  const handleInputChangeInterest = (e) => {
    // Function for "Areas of Interest" input
    const value = e.target.value;
    setInputValueInterest(value);
    setShowSuggestionsInterest(true);

    if (value.trim() !== "" && value.length >= 3) {
      const suggestions = areaofInterest.filter((interest) =>
        interest.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestionsInterest(suggestions);
    } else {
      setFilteredSuggestionsInterest([]);
    }
  };
  const handleSuggestionClick = (skill) => {
    if (!chips.find((chip) => chip.id === skill.id)) {
      const updatedChips = [...chips, skill];
      setChips(updatedChips);
      setSelectedSkills((prevSkills) => {
        const updatedSkills = [...prevSkills, skill.id];
        localStorage.setItem('selectedSkills', JSON.stringify(updatedSkills));
        return updatedSkills;
      });
    }
    setInputValue(""); // Clear input field after selection
    setShowSuggestions(false); // Hide dropdown
  };
  // useEffect(() => {
  //     console.log("Updated selectedSkills:", selectedSkills);
  // }, [selectedSkills]);

  const handleSuggestionClickInterest = (interest) => {
    if (!interestChips.find((chip) => chip.id === interest.id)) {
      const updatedInterestChips = [...interestChips, interest];
      setInterestChips(updatedInterestChips);
      setselectedIntrest((prev) => {
        const updatedInterests = [...prev, interest.id];
        localStorage.setItem('selectedInterests', JSON.stringify(updatedInterests));
        return updatedInterests;
      });
    }
    setInputValueInterest(""); // Clear input field after selection
    setShowSuggestionsInterest(false); // Hide dropdown
  };

  const removeChip = (indexToRemove) => {
    const updatedChips = chips.filter((_, index) => index !== indexToRemove);
    setChips(updatedChips);

    // Update the selected skills array
    const updatedSelectedSkills = selectedSkills.filter((_, index) => index !== indexToRemove);
    setSelectedSkills(updatedSelectedSkills);

    // Show error if no skills are left
    if (updatedSelectedSkills.length === 0) {
      showErrorWithTimeout(setSkillError, 'Please select at least one skill.');
    } else {
      setSkillError(''); // Clear error
    }
  };

  const removeInterestChip = (chipId) => {
    const updatedInterestChips = interestChips.filter((chip) => chip.id !== chipId);
    setInterestChips(updatedInterestChips);

    // Update the selected interests array
    const updatedSelectedInterest = selectedIntrest.filter((id) => id !== chipId);
    setselectedIntrest(updatedSelectedInterest);

    // Show error if no interests are left
    if (updatedSelectedInterest.length === 0) {
      showErrorWithTimeout(setInterestError, 'Please select at least one area of interest.');
    } else {
      setInterestError(''); // Clear error
    }
  };


  useEffect(() => {
    if (!_.isEmpty(userDetailRes)) {
      let name =
        `${userDetailRes?.payload?.payload?.firstname}` +
        " " +
        `${userDetailRes?.payload?.payload?.lastname}`;

      let role = userDetailRes?.payload?.payload?.roles;
      let userRole = "";
      if (role?.includes("realtor")) {
        userRole = "End user";
      } else if (role?.includes("manager")) {
        userRole = "Manager";
      } else if (role?.includes("instructor")) {
        userRole = "Instructor";
      } else if (role?.includes("host")) {
        userRole = "host";
      } else if (role?.includes("broker_admin")) {
        userRole = "admin";
      } if (role?.includes("participant")) {
        userRole = "End user";
      }

      let email = userDetailRes?.payload?.payload?.email;
      let location = userDetailRes?.payload?.payload?.office_province;

      setUserDetails({
        name: name,
        role: userRole,
        email: email,
        location: location,
      });
    }
  }, [userDetailRes]);

  useEffect(() => {
    const newDefaultValue = selectedSkillSet.map((skill) => ({
      value: skill.id,
      label: skill.name,
    }));
    setDefaultValue(newDefaultValue);
    console.log("stl--", selectedSkillSet, newDefaultValue);
  }, [selectedSkillSet]);

  const validatePhoneNumber = () => {
    if (!phoneNumber) {
      setError("Mobile number is required.");
      hideErrorAfterTimeout();
      return false;
    }
    if (phoneNumber.length !== 10) {
      setError("Mobile number must be exactly 10 digits.");
      hideErrorAfterTimeout();
      return false;
    }
    setError(""); // Clear error if validation passes
    return true;
  };
  
  const hideErrorAfterTimeout = () => {
    setTimeout(() => {
      setError("");
    }, 3000); // Clear error after 3 seconds
  };
  

  const validateTotalExperience = () => {
    if (!selectedExperience) {
      setExperienceError("Please select your total experience.");
      hideExperienceErrorAfterTimeout();
      return false;
    }
    setExperienceError(""); // Clear error if validation passes
    return true;
  };
  
  const hideExperienceErrorAfterTimeout = () => {
    setTimeout(() => {
      setExperienceError("");
    }, 3000); // Clear error after 3 seconds
  };
  
  const validateSkills = () => {
    if (_.isEmpty(selectedSkillSet)) {
      setSkillsError("Please select at least one skill.");
      hideSkillsErrorAfterTimeout();
      return false;
    }
    setSkillsError(""); // Clear error if validation passes
    return true;
  };
  
  const hideSkillsErrorAfterTimeout = () => {
    setTimeout(() => {
      setSkillsError("");
    }, 3000); // Clear error after 3 seconds
  };
  
  const handleNextValidation = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    const isPhoneNumberValid = validatePhoneNumber();
    const isIndustryValid = validateIndustrySegment();
    const isExperienceValid = validateTotalExperience();
    const areSkillsValid = validateSkills();
  
    if (isPhoneNumberValid && isIndustryValid && isExperienceValid && areSkillsValid) {
      // Proceed to the next step
      setStep((prev) => prev + 1);
      console.log("All inputs are valid. Proceeding...");
    }
  };

  const validateIndustrySegment = () => {
    if (!selectedIndustry) {
      setIndustryError("Please select an industry segment.");
      hideIndustryErrorAfterTimeout();
      return false;
    }
    setIndustryError(""); // Clear error if validation passes
    return true;
  };

  const hideIndustryErrorAfterTimeout = () => {
    setTimeout(() => {
      setIndustryError("");
    }, 3000); // Clear error after 3 seconds
  };
  

  return (
    <>
      <Page>
        <Loader start={isLoading} />
        <section className="coaching-form">
          <div className="container mt-4">
            <button
              className="mb-4 bck-btn"
              onClick={() => navigate("/learn/coaching-services")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="17"
                viewBox="0 0 10 17"
                fill="none"
              >
                <path
                  d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                  fill="black"
                />
              </svg>{" "}
              {t("back")}
            </button>
            <h3 className="mentor-title mb-0">{t("mentorDetails")}</h3>
            <div className="d-flex mt-4 couaching-tabs">
              <button
                //variant={step === 1 ? "primary" : "light"}
                className={step === 1 ? "tab active" : "tab"}
                //disabled
              >
                {t("step1")}
              </button>
              <button
                //variant={step === 2 ? "primary" : "light"}
                className={step === 2 ? "tab active" : "tab"}
                //disabled
              >
                {t("step2")}
              </button>
            </div>

            {step === 1 && (
              <Form
                className="mt-4"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              >
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group
                      className="frm-box"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent Enter key from submitting the form
                        }
                      }}
                    >
                      <Form.Label>{t("name")}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t("enterName")}
                        value={userDetails?.name}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>{t("role")}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t("enterRole")}
                        value={userDetails?.role}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group
                      className="frm-box justify-content-start"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent Enter key from submitting the form
                        }
                      }}
                    >
                      <Form.Label>{t("mobileNumber")}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t("enterMobileNumber")}
                        value={phoneNumber} // Controlled component
                        maxLength={10} // Limit input to 10 characters
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            // Allow only numbers
                            setPhoneNumber(value);
                          }
                        }}
                        onBlur={validatePhoneNumber} // Validate on blur
                      />
                      {error && (
                        <Form.Text className="text-danger">{error}</Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="frm-box justify-content-start"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent Enter key from submitting the form
                        }
                      }}
                    >
                      <Form.Label>{t("emailAddress")}</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder={t("enterEmail")}
                        value={userDetails?.email}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="frm-box justify-content-start">
                      <Form.Label>{t("currentLocation")}</Form.Label>
                      <Form.Select disabled>
                        <option selected>{userDetails?.location}</option>
                        {/* Add options here */}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <div className="d-flex flex-column">
                        <Form.Label>{t("skills")}</Form.Label>
                        <Select
                          isMulti
                          name="skills"
                          className="basic-multi-select w-100 multi-label-select"
                          classNamePrefix="xsel"
                          placeholder={t("selectSkills")}
                          options={skillsList}
                          value={selectedSkillSet.map((skill) => ({
                            value: skill.id,
                            label: skill.name,
                          }))} // Map selected skills to match Select's format
                          isLoading={isLoading}
                          onChange={(e) => {
                            if (!_.isEmpty(e)) {
                              const selectedData = e.map((option) => ({
                                id: option.value,
                                name: option.label,
                              }));
                              setSelectedSkillSet(selectedData);
                              localStorage.setItem(
                                "selectedSkillSet",
                                JSON.stringify(selectedData)
                              );
                            } else {
                              setSelectedSkillSet([]);
                              localStorage.setItem(
                                "selectedSkillSet",
                                JSON.stringify([])
                              );
                            }
                          }}
                          onBlur={validateSkills} // Validate on blur (optional)
                          components={{ MultiValue: () => null }} // Hide selected values in the input
                          //menuIsOpen={true} 
                        />
                      </div>

                      {/* Selected Skills Chips */}
                      <div className="selected-skills mt-2">
                        {selectedSkillSet.map((skill) => (
                          <span key={skill.id} className="skill-tag">
                            {skill.name}
                            <button
                              type="button"
                              className="remove-skill-btn"
                              onClick={() => {
                                const updatedSkills = selectedSkillSet.filter(
                                  (selectedSkill) =>
                                    selectedSkill.id !== skill.id
                                );
                                setSelectedSkillSet(updatedSkills);
                                localStorage.setItem(
                                  "selectedSkillSet",
                                  JSON.stringify(updatedSkills)
                                );
                              }}
                            >
                              ✕
                            </button>
                          </span>
                        ))}
                      </div>

                      {skillsError && (
                        <Form.Text className="text-danger mt-2">
                          {skillsError}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>{t("totalExperience")}</Form.Label>
                      <Form.Select
                        onChange={(ev) => {
                          const value = ev.target.value;
                          setSelectedExperience(value);
                          localStorage.setItem("selectedExperience", value);
                        }}
                        value={selectedExperience}
                        onBlur={validateTotalExperience} // Validate on blur (optional)
                      >
                        <option value="">{t("selectExperience")}</option>
                        {experience.map((ex, index) => {
                          return (
                            <option value={ex?.value} key={index}>
                              {ex?.value}
                            </option>
                          );
                        })}
                      </Form.Select>
                      {experienceError && (
                        <Form.Text className="text-danger">
                          {experienceError}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>{t("industrySegment")}</Form.Label>
                      <Form.Select
                        value={selectedIndustry}
                        onChange={(ev) => {
                          setSelectedIndustry(ev.target.value);
                        }}
                        onBlur={validateIndustrySegment} // Validate on blur (optional)
                      >
                        <option value="">{t("selectSegment")}</option>
                        {industry.map((ind, index) => {
                          return (
                            <option value={ind?.name} key={index}>
                              {ind?.name}
                            </option>
                          );
                        })}
                      </Form.Select>
                      {industryError && (
                        <Form.Text className="text-danger">
                          {industryError}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex justify-content-end gap-3 btn-footer">
                  <button
                    className="btn-primary"
                    onClick={() => navigate("/learn/coaching-services")}
                  >
                    {t("cancel")}
                  </button>
                  <button
                    className="btn-primary active-page"
                    type="button"
                    onClick={(e) => handleNextValidation(e)}
                  >
                    {t("next")}
                  </button>
                </div>
              </Form>
            )}

            {step === 2 && (
              <Form className="sills-form mt-4">
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group
                      className="frm-box align-items-start"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent Enter key from submitting the form
                        }
                      }}
                    >
                      <Form.Label>{t("skills")}</Form.Label>
                      <div className="d-flex flex-column w-100">
                        <div className="frmdorp position-relative">
                          <Form.Control
                            type="text"
                            placeholder={t("chooseSkills")}
                            value={inputValue}
                            onChange={handleInputChange}
                          />
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="cursor-pointer"><path d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z" fill="black"></path></svg>
                              {showSuggestions &&
                          inputValue &&
                          filteredSuggestions.length > 0 && (
                            <ul className="dropdown-menu d-block p-0 m-0">
                              {filteredSuggestions.map((skill) => (
                                <div
                                  key={skill.id}
                                  className="suggestion-item cursor-pointer"
                                  onClick={() => handleSuggestionClick(skill)}
                                >
                                  {skill.name}
                                </div>
                              ))}
                            </ul>
                          )}
                        </div>
                     
                      </div>
                      <div className="selected-skills mt-2">
                        {chips.map((chip, index) => (
                          <span key={chip.id} className="skill-tag">
                            {chip.name} {/* Render the name */}
                            <button
                              type="button"
                              className="remove-skill-btn"
                              onClick={() => removeChip(index)}
                            >
                              ✕
                            </button>
                          </span>
                        ))}
                      </div>
                      {skillError && (
                        <div className="text-danger mt-2">{skillError}</div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="frm-box align-items-start">
                      <div className="d-flex flex-column w-100">
                        <Form.Label>{t("areasOfInterest")}</Form.Label>
                        <div className="frmdorp position-relative">
                          <Form.Control
                            type="text"
                            placeholder={t("chooseInterests")}
                            value={inputValueInterest}
                            onChange={handleInputChangeInterest}
                          />
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="cursor-pointer"><path d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z" fill="black"></path></svg>
                          {showSuggestionsInterest &&
                          inputValueInterest &&
                          filteredSuggestionsInterest.length > 0 && (
                            <ul className="dropdown-menu d-block p-0 m-0">
                              {filteredSuggestionsInterest.map((interest) => (
                                <div
                                  key={interest.id}
                                  className="suggestion-item cursor-pointer"
                                  onClick={() =>
                                    handleSuggestionClickInterest(interest)
                                  }
                                >
                                  {interest.name}
                                </div>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                      <div className="selected-skills mt-2">
                        {interestChips.map((chip) => (
                          <span key={chip.id} className="skill-tag">
                            {chip.name}
                            <button
                              type="button"
                              className="remove-skill-btn"
                              onClick={() => removeInterestChip(chip.id)} // Pass the chip's id to remove the chip
                            >
                              ✕
                            </button>
                          </span>
                        ))}
                      </div>
                      {interestError && (
                        <div className="text-danger mt-2">{interestError}</div>
                      )}
                    </Form.Group>

                    {/* Selected interests chips */}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>
                      {t("describeYourGoalsAndMotivations")}
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder={t("typeHere")}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>{t("describeYourGreatestStrength")}</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder={t("typeHere")}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>
                      {t("describeAnyChallenges")}
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder={t("typeHere")}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>
                      {t("describeYourCharacteristics")}
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder={t("typeHere")}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>
                      {t("isThereAnythingElseYouThink")}
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder={t("typeHere")}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>
                      {t("doYouAlreadyHaveMatchPreference")}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        rows={1}
                        placeholder={t("typeHere")}
                        onChange={(e) => setMentorNames(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>{t("numberOfDirectReports")}</Form.Label>

                      <Form.Select
                        value={directReports}
                        onChange={(ev) => {
                          setDirectReports(ev.target.value);
                        }}
                      >
                        <option value="">{t("selectNumber")}</option>
                        <option>10 </option>
                        <option>50</option>
                        <option>100</option>
                        <option>200+</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>
                      {t("preferredModeOfCommunication")}{" "}
                      </Form.Label>
                      <Form.Select
                        value={preferredMode} // Bind the value to state
                        onChange={(ev) => {
                          setPreferredMode(ev.target.value); // Update state
                        }}
                      >
                        <option value="">{t("selectMode")}</option>
                        <option>Online</option>
                        <option>Offline</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>{t("periodOfMentoring")}</Form.Label>
                      <Form.Select
                        value={mentoringPeriod} // Bind the value to state
                        onChange={(ev) => {
                          setMentoringPeriod(ev.target.value); // Update state
                        }}
                      >
                        <option value="">{t("selectNumber")}</option>
                        <option>10 Days</option>
                        <option>1 Month</option>
                        <option>3 Months</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex justify-content-end gap-3 btn-footer">
                  <button
                    className="btn-primary"
                    onClick={() => navigate("/learn/coaching-services")}
                  >
                    {t("cancel")}
                  </button>
                  <button className="btn-primary" onClick={handlePrevious}>
                  {t("previous")}
                  </button>
                  <button
                    className="btn-primary active-page"
                    onClick={handleSubmit}
                  >
                    {t("submit")}
                  </button>
                </div>
              </Form>
            )}
          </div>
        </section>
      </Page>
    </>
  );
}

export default CoachingRequestForm;
